import { Heading, Box, UnorderedList, ListItem } from '@dapperlabs/core-fe';
import React from 'react';

import { AboutEventCard } from '../Cards/AboutEventCard';
import { SectionProps } from '../models';

export const AboutLaLigaEvents: React.FC<SectionProps> = ({
  sectionHeading,
  cards,
}) => {
  return (
    <Box
      as='section'
      mt={['4rem', '4rem', '4rem', '4rem', '6.5rem']}
      px={['1rem', '1rem', '1rem', '1rem', 0]}
      py='4rem'
      bgColor='gray.800'
    >
      <Heading fontFamily='heading' textAlign='center'>
        {sectionHeading}
      </Heading>

      <UnorderedList
        justifyContent={['center', 'center']}
        flexDirection={['column', 'column', 'row']}
        gap={['1rem', '1rem', '3rem']}
        display='flex'
        maxW={['375px', '375px', '75rem']}
        m='auto'
        pt={['0.5rem', '3rem']}
        listStyleType='none'
      >
        {cards.map(({ fields }) => (
          <ListItem
            key={fields.cardHeading}
            position='relative'
            justifyContent='space-between'
            flexDirection='column'
            flexBasis={['auto', 'auto', '23.5rem']}
            display='flex'
            mt={['2rem', '2rem', 0]}
            borderBottom={`1px solid ${fields.color}`}
            borderLeft={`1px solid ${fields.color}`}
          >
            <AboutEventCard
              color={fields.color}
              cardHeading={fields.cardHeading}
              cardText={fields.cardText}
              isDarkText={fields.isDarkText}
            />
          </ListItem>
        ))}
      </UnorderedList>
    </Box>
  );
};
